import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Button from '@mui/material/Button';
import { Divider } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import useActivityAudio from '@monorepo/shared/src/hooks/use-activity-audio';
import { tA11y } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { useSoundOutWords } from 'state/hooks/use-sound-out-words';

const ActivityFooter: FC = () => {
  const classes = useStyles();
  const [{ isPlaying }] = useActivityAudio();
  const [
    { orderedWords, selectedWord, activityStarted },
    { setSelectedWord /*,setSpelledCharacter */ },
  ] = useSoundOutWords();

  if (!activityStarted) return <></>;

  const { index } = selectedWord;
  const firstWordSelected = index === orderedWords[0].order;
  const lastWordSelected = index === orderedWords[orderedWords.length - 1].order;

  const handleNextWord = (): void => {
    const nextWord = orderedWords.find((word) => word.order >= index + 1);
    if (nextWord) {
      setSelectedWord(nextWord.order);
    }
  };

  const handlePreviousWord = (): void => {
    const previousWord = orderedWords
      .slice()
      .reverse()
      .find((word) => word.order <= index - 1);

    if (previousWord) {
      setSelectedWord(previousWord.order);
    }
  };

  return (
    <>
      <Divider />
      <div className={classes.footer}>
        <Button
          className={`${firstWordSelected || isPlaying ? classes.disabled : ''} ${classes.btn} `}
          disabled={isPlaying || firstWordSelected}
          aria-label={tA11y('buttons.previousWord')}
          onClick={handlePreviousWord}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          <span className={classes.text}>Previous Word</span>
        </Button>
        {/* <ActivityPlayer callback={setSpelledCharacter} /> */}
        <Button
          className={`${lastWordSelected || isPlaying ? classes.disabled : ''} ${classes.btn} `}
          disabled={isPlaying || lastWordSelected}
          aria-label={tA11y('buttons.nextWord')}
          onClick={handleNextWord}
        >
          <span className={classes.text}>Next Word</span>
          <FontAwesomeIcon icon={faArrowRight} />
        </Button>
      </div>
    </>
  );
};

export default ActivityFooter;

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '4rem',
    alignItems: 'center',
    margin: 'auto 1rem',
  },
  btn: {
    backgroundColor: 'black',
    color: 'white',
  },
  disabled: {
    backgroundColor: theme.palette.grey[100],
  },
  text: {
    padding: '0 10px',
    fontWeight: 'bold',
  },
}));
